import { TrendingUp, Clock, BarChart3, DollarSign } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { StatCard, SectionHeader, ChartTooltipContent, fmt$ } from "./ReportsShared";

export const ClosingMetricsSection = ({ closing_metrics, pipeline }) => (
  <section data-testid="section-closing" id="section-closing">
    <SectionHeader icon={TrendingUp} title="Closing Metrics" subtitle="Speed, volume, and projections" />
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
      <StatCard icon={Clock} label="Avg Days to Close" value={closing_metrics.avg_days_to_close || "—"} color="#2563eb" />
      <StatCard icon={TrendingUp} label="Total Closed" value={closing_metrics.total_closed} color="#059669" />
      <StatCard icon={BarChart3} label="Projected (30d)" value={closing_metrics.projected_closings["30"]} sub={`${closing_metrics.projected_closings["60"]} in 60d · ${closing_metrics.projected_closings["90"]} in 90d`} color="#D97706" />
      <StatCard icon={DollarSign} label="Pipeline Total" value={fmt$(pipeline.total_volume)} color="#7c3aed" />
    </div>
    <Card className="card-surface" data-testid="closings-monthly-chart">
      <CardHeader className="py-3 px-5">
        <CardTitle className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Closings by Month</CardTitle>
      </CardHeader>
      <CardContent className="px-2 pb-4">
        {closing_metrics.closings_by_month.length > 0 ? (
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={closing_metrics.closings_by_month} barSize={28}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--t-border)" />
              <XAxis dataKey="month" tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} />
              <YAxis tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} allowDecimals={false} />
              <Tooltip content={<ChartTooltipContent />} />
              <Bar dataKey="count" name="Closings" fill="#059669" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-center py-10 text-sm" style={{ color: "var(--t-text-muted)" }}>No closings recorded yet</p>
        )}
      </CardContent>
    </Card>
  </section>
);
